import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { CustomerBillingPermission, CustomerFullDto } from '@nusign/picflow-backend-types';
import { filter, map, switchMap } from 'rxjs';
import { PICFLOW_CONFIG } from '../picflow-config';
import { SubscriptionService } from './subscription.service';

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  private config = inject(PICFLOW_CONFIG);
  private http = inject(HttpClient);
  private subscriptionService = inject(SubscriptionService);

  public getBillingCustomer(includeTaxId = false) {
    return this.subscriptionService.getSubscription().pipe(
      filter(Boolean),
      switchMap(() =>
        this.http.get<{
          customer: CustomerFullDto;
          billing_permissions: CustomerBillingPermission;
        }>(`${this.config.apiEndpoint}/billing/customer${includeTaxId ? '?expand[]=tax_ids' : ''}`)
      )
    );
  }

  public getBalance() {
    return this.getBillingCustomer().pipe(map(customer => -customer.customer.balance));
  }
}
